import { Routes } from '@angular/router';

import { PublicGuard } from 'src/app/utils/public.guard';
import { LoginComponent } from 'src/app/public/login/login.component';
import { ForgetComponent } from 'src/app/public/forget/forget.component';
import { ResetComponent } from 'src/app/public/reset/reset.component';
import { NotFoundComponent } from 'src/app/public/not-found/not-found.component';
import { MainComponent } from 'src/app/private/layout/main/main.component';
import { AuthGuard } from 'src/app/utils/auth.guard';
import { OrganizationComponent } from 'src/app/private/modules/organization/organization.component';
import { ClientsComponent } from 'src/app/private/modules/clients/clients.component';
import { ClientDetailsComponent } from 'src/app/private/components/clients/client-details/client-details.component';
import { PackagesComponent } from 'src/app/private/modules/packages/packages.component';
import { FeaturesComponent } from 'src/app/private/modules/features/features.component';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: "full",
    title: "TINA"
  },

  {
    path: 'login',
    component: LoginComponent,
    title: "TINA",
    canActivate: [PublicGuard]
  },
  {
    path: 'forget-password',
    component: ForgetComponent,
    title: "Forget Password",
    canActivate: [PublicGuard]
  },
  {
    path: 'reset-password/:type/:token',
    component: ResetComponent,
    title: "Reset Password",
    canActivate: [PublicGuard]
  },

  {
    path: 'main',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        redirectTo: 'clients',
        pathMatch: 'full' // Ensures an exact match to redirect
      },
      {
        path: 'clients',
        component: ClientsComponent,
        title: "Manage Clients",
        data: {
          title: "Manage Clients",
        }
      },
        {
        path: 'clients/:id',
        component: ClientDetailsComponent,
        title: "Manage Clients",
        data: {
          title: "Manage Clients",
        }
      },
      {
        path: 'packages',
        component: PackagesComponent,
        title: "Manage Packages",
        data: {
          title: "Manage Packages"
        }
      },
      {
        path: 'features',
        component: FeaturesComponent,
        title: "Manage Features",
        data: {
          title: "Manage Features"
        }
      },
    ]
  },


  { path: 'notfound', component: NotFoundComponent },
  { path: '**', redirectTo: '/notfound' }
];
